import { BaseService } from './base.service';
import { CustomResponseEntity } from '../types/common';
import { ProgramLevelDto } from '../types/dtos/program';
import { PaginationParams } from '../types/common';

/**
 * ProgramLevelService handles CRUD operations for program levels.
 *
 * URL Pattern: /api/v1/programs/{programId}/levels
 * Organization context is provided via X-Organization-Id header (injected by axiosClient).
 *
 * Migration: The organizationId parameter has been removed from URL paths. The backend
 * extracts organization context from the X-Organization-Id header for tenant scoping.
 *
 * VAL-PRG-003: ProgramLevel List with X-Organization-Id Header
 *
 * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
 * @param programId - Parent program UUID for nested resource path
 */
export class ProgramLevelService extends BaseService<ProgramLevelDto> {
  /**
   * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
   * @param programId - Parent program UUID for nested resource path
   */
  constructor(_organizationId: string, programId: string) {
    super(`/api/v1/programs/${programId}/levels`);
  }

  findAll(params?: PaginationParams & { isActive?: boolean }): Promise<CustomResponseEntity<ProgramLevelDto[]>> {
    return super.findAll(params);
  }
}

/**
 * Factory function to create a ProgramLevelService instance
 * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
 * @param programId - Parent program UUID for nested resource path
 */
export const createProgramLevelService = (
  _organizationId: string,
  programId: string
) => new ProgramLevelService(_organizationId, programId);

